import { styled } from '@mui/styles';
import Box from '@mui/material/Box';

export const StyledCampaign = styled(Box)(({ theme }) => ({

    '& .HeaderMainStack': {
        position: 'absolute',
        width: '100%',
        zIndex: '3',
        boxShadow: 'none',
        color: '#fff',

        '& svg': {
            color: '#fff'
        }
    },

    '& h4': {
        fontWeight: 'bold'
    },

    '& .Loader': {
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    },
    '& .CampaignCoverBox': {
        height: '560px',
        display: 'flex',
        color: 'white',
        alignItems: 'center',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        position: 'relative',

        [theme.breakpoints.down('md')]: {
            alignItems: 'unset',
            paddingTop: '150px'
        },


        '& .Overlay': {
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            right: 0,
            backgroundColor: 'rgba(0,0,0,0.3)',
            zIndex: 1,
            cursor: 'pointer'
        },

        '& .CampaignDetailsContainer': {
            zIndex: 1
        },

        [theme.breakpoints.down('sm')]: {
            height: '100vh',
            justifyContent: 'center',
            textAlign: 'center'
        },
        '& .CampaignCoverStack': {
            width: '55%',
            margin: 'auto',

            '& .ButtonsStack': {
                flexDirection: 'row',
                justifyContent: 'center',
                gap: '16px',

                '& button, a': {
                    fontWeight: 600,
                    fontSize: '1rem',
                    minWidth: '156px',
                    '&:hover': {
                        backgroundColor: 'transparent'
                    }
                },

                '& .StartFundraiserButton': {
                    border: `1px solid ${theme.palette.primary.main}`,

                    '&:hover': {
                        borderColor: '#fff'
                    }
                },

                '& .DonateNowButton': {
                    border: `1px solid ${theme.palette.secondary.main}`,

                    '&:hover': {
                        color: theme.palette.secondary.main,
                    }
                }
            },

            [theme.breakpoints.down('sm')]: {
                width: '100%',
            }
        },
        // '& .MuiContainer-root': {
        //     [theme.breakpoints.down('sm')]: {
        //         position: 'absolute',
        //         top: '110px'
        //     }
        // }
    },

    '& .CampaignSection': {
        padding: '35px 0',

        '& .Description': {
            width: '55%',
            margin: 'auto',
            textAlign: 'center',

            [theme.breakpoints.down('sm')]: {
                width: '100%'
            }
        },

    },
    '& .CampaignSectionContainer-1': {
        backgroundColor: theme.palette.primary.main,
        color: '#fff'
    },
    '& .CampaignFundraisersContainer': {
        '& .infinite-scroll-component': {
            overflow: 'hidden !important',

            '& .MuiGrid-container': {
                marginTop: 0,

                '& .MuiGrid-item': {
                    [theme.breakpoints.down('sm')]: {
                        maxWidth: 'calc(50% - 2.5px)'
                    }
                },

                [theme.breakpoints.down('sm')]: {
                    gap: '2.5px'
                }
            }
        }
    }
}));
